// extracted by mini-css-extract-plugin
export default {"card":"InfoPopup_card__kRVlZ"};